import { useFetchNew } from '../data/fetch/useFetch';
import { parseTournamentData } from '../data/parseTournamentData';
import { getConfiguration, getPrincipaleOPrimoGruppo } from '../data/utils';
import { usePrematchData } from './PrematchDataFetcher';
import Loader from '../common/Loader';

function Fetcher(props) {
    const prematchData = usePrematchData();
    const conf = getConfiguration();

    const tournament = props.data;
    const aggId = getPrincipaleOPrimoGruppo(tournament.aggregate).idAggregata;

    const [isLoading, isError, data] = useFetchNew(conf.api.getTorneoCentrale, {
        sportId: tournament.sportRef,
        categoryId: tournament.categoryRef,
        tournamentId: tournament.id,
        idAggregata: aggId
    }, (data) =>
        parseTournamentData(prematchData, data, tournament.uniqueId, aggId, false, true)
    );

    if (isLoading) {
        return <div className="c_43"></div>
    } else if (isError) {
        return (
            <Loader error={isError} />
        );
    }

    return props.renderItem(data);
}

export default function TournamentFetcher(props) {
    const tournamentData = props.data;

    if (tournamentData == null) {
        return null;
    }

    return <Fetcher key={tournamentData.uniqueId} data={tournamentData} renderItem={props.renderItem} />;
}
